import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6f6cdf7c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6f6cdf7c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6cdf7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f6cdf7c')) {
      api.createRecord('6f6cdf7c', component.options)
    } else {
      api.reload('6f6cdf7c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6f6cdf7c&scoped=true", function () {
      api.rerender('6f6cdf7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/statistics/studentConsumDetail/index.vue"
export default component.exports